import ModuleDetails from './container'
export default ModuleDetails
